import { request } from './base';

export interface CompPoints {
  chargeable?: {
    points: number;
  };
  persistent?: {
    points: number;
  };
}

export const compPoints = () =>
  request<CompPoints>({
    url: 'player/comp_points',
  });

export interface ExchangeCompointsPayload {
  group: string;
  points: number;
  currency: string;
}

const exchange = (type: string) => (data: ExchangeCompointsPayload) =>
  request<null>({
    method: 'POST',
    url: `comp_points/exchange/${type}`,
    data: { exchange: data },
  });

export const exchangeCompointsMoney = exchange('money');
export const exchangeCompointsFreespins = exchange('freespins');
export const exchangeCompointsLootboxes = exchange('lootboxes');
